export default "__VITE_ASSET__D0kdmF84__"